import { TopBarSection } from "@/components/shared/SecaoBarraSuperior";
import { PageTabs } from "@/components/shared/PageTabs";
import { SquadCreateFormDialog } from "@/components/squad/components/SquadCreateFormDialog";
import { SquadListTable } from "@/components/squad/SquadListComponent";
import { SquadEstatisticasPanel } from "@/components/squad/SquadEstatisticasPanel";
import { Button } from "@/components/ui/button";
import { BarChart3, Boxes, List } from "lucide-react";
import { useState } from "react";

export function SquadAdminListPage() {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <div className="flex flex-col space-y-6 pb-10 duration-500 animate-in fade-in">
      <TopBarSection
        entity="Squad"
        title="Gestão de Squads"
        extraActions={[
          <Button
            key="create"
            size="sm"
            onClick={() => setIsCreateModalOpen(true)}
            className="gap-2 bg-purple-600 text-white shadow-sm hover:bg-purple-700"
          >
            <Boxes className="h-4 w-4" />
            Novo Squad
          </Button>,
        ]}
      />

      <PageTabs
        paramKey="tab"
        tabs={[
          {
            value: "lista",
            label: "Squads",
            icon: List,
            content: (
              <div className="rounded-xl border border-border bg-card p-6 shadow-sm">
                <SquadListTable storageKey="squads-list-v1" />
              </div>
            ),
          },
          {
            value: "estatisticas",
            label: "Estatísticas",
            icon: BarChart3,
            content: <SquadEstatisticasPanel />,
          },
        ]}
      />

      <SquadCreateFormDialog open={isCreateModalOpen} onOpenChange={setIsCreateModalOpen} />
    </div>
  );
}
